import { useI18n } from 'builder/hooks/useI18n'
import { ButtonTheme } from 'builder/components/Button'

import { TRANSLATION } from '../constants'
import { useCoachBanner } from '../hooks/useCoachBanner'

import * as Styles from './styles'

export const CoachActions = () => {
  const { i18n } = useI18n()
  const { closeBanner, handleBookCoachPromo } = useCoachBanner()

  return (
    <Styles.Container>
      <Styles.InfoContainer>
        <Styles.Text>{i18n.t(`${TRANSLATION}.actions.description`)}</Styles.Text>
      </Styles.InfoContainer>
      <Styles.ActionsContainer>
        <Styles.ActionButton onClick={handleBookCoachPromo} theme={ButtonTheme.ghost}>
          {i18n.t(`${TRANSLATION}.actions.book_coach`)}
        </Styles.ActionButton>
        <Styles.ActionButton onClick={closeBanner}>
          {i18n.t(`${TRANSLATION}.actions.next_step`)}
        </Styles.ActionButton>
      </Styles.ActionsContainer>
    </Styles.Container>
  )
}
